import React from 'react';
import { Box, Typography, Paper, Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ChatMessageProps {
  content: string;
  role: 'user' | 'assistant';
  timestamp: string;
}

const MessageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginBottom: theme.spacing(2),
}));

const MessageContent = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'isUser',
})<{ isUser: boolean }>(({ theme, isUser }) => ({
  padding: theme.spacing(2),
  maxWidth: '70%',
  borderRadius: 12,
  backgroundColor: isUser ? theme.palette.primary.light : theme.palette.grey[100],
  color: isUser ? theme.palette.primary.contrastText : theme.palette.text.primary,
}));

const TimeStamp = styled(Typography)(({ theme }) => ({
  fontSize: '0.7rem',
  color: theme.palette.text.secondary,
  marginTop: 4,
}));

const ChatMessage: React.FC<ChatMessageProps> = ({ content, role, timestamp }) => {
  const isUser = role === 'user';
  const formattedTime = new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  return (
    <MessageContainer sx={{ justifyContent: isUser ? 'flex-end' : 'flex-start' }}>
      {!isUser && (
        <Avatar 
          sx={{ 
            bgcolor: 'primary.main', 
            width: 36, 
            height: 36, 
            mr: 1,
            mt: 0.5 
          }}
        >
          B
        </Avatar>
      )}
      <Box>
        <MessageContent isUser={isUser}>
          <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
            {content}
          </Typography>
        </MessageContent>
        <TimeStamp align={isUser ? 'right' : 'left'}>
          {formattedTime}
        </TimeStamp>
      </Box>
      {isUser && (
        <Avatar 
          sx={{ 
            bgcolor: 'secondary.main', 
            width: 36, 
            height: 36, 
            ml: 1,
            mt: 0.5  
          }}
        >
          U
        </Avatar>
      )}
    </MessageContainer>
  );
};

export default ChatMessage;
